import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the API
 */
export class DataRetentionService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getDataRetentionPolicies(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/data-retention-policies' + params);		
		return data;
	}	
	
	async getDataRetentionPolicy(policyId) {
		var data = await this.makeGETRequest('/api/resource/data-retention-policies/' + policyId);		
		return data;
	}	
	
	async saveDataRetentionPolicy(policy, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/data-retention-policies/' + policy.policyId, policy);
		} else {
			saved = await this.makePOSTRequest('/api/resource/data-retention-policies', policy);
		}
		return saved;
	}	
	
	async deleteDataRetentionPolicy(datafilterId) {
		var data = await this.makeDELETERequest('/api/resource/data-retention-policies/' + datafilterId);		
		return data;		
	}	
	
}

